import { writable } from "svelte/store";

export interface ProductLineLastOrderedProduct {
  case_quantity: number;
  container_label: string;
  container_type: string;
  product_id: number;
  unit_quantity: number;
  vintage_year: number | null;
}

export interface ProductLineLastOrderedOrder {
  distributor_name: string;
  order_products: ProductLineLastOrderedProduct[];
}

export interface ProductLineLastOrdered {
  submitted_at: string;
  orders: ProductLineLastOrderedOrder[];
}

type ProductLinesLastOrderedById = Record<string, ProductLineLastOrdered | null>;

export interface ProductLineLastOrderedStore {
  lastOrdered: ProductLinesLastOrderedById;
  getLastOrderedForProductLine(productLineId: number): ProductLineLastOrdered | null;
  hasDataForProductLine(productLineId: number): boolean;
}

const buildGetters = (productLinesLastOrdered: ProductLinesLastOrderedById) => {
  const getLastOrderedForProductLine = productLineId =>
    productLinesLastOrdered[productLineId] || null;

  const hasDataForProductLine = productLineId =>
    Object.keys(productLinesLastOrdered).map(Number).includes(productLineId);

  return {
    getLastOrderedForProductLine,
    hasDataForProductLine,
  };
};

const store = writable<ProductLineLastOrderedStore>({
  lastOrdered: {},
  ...buildGetters({}),
});

const { subscribe, update } = store;

const updateForProductLine = (
  productLineId: number,
  productLineLastOrdered: ProductLineLastOrdered,
): void => {
  update((currentStore: ProductLineLastOrderedStore) => {
    const nextLastOrdered: ProductLinesLastOrderedById = {
      ...currentStore.lastOrdered,
      [productLineId]: productLineLastOrdered,
    };

    return {
      lastOrdered: nextLastOrdered,
      ...buildGetters(nextLastOrdered),
    };
  });
};

export default { subscribe, updateForProductLine };
